import { useLocation, useNavigate } from "react-router-dom";
import { NAVIGATION_ITEMS } from "../utils/constants";
import { BarChart2, FileText, Wand2 } from "lucide-react";

export const HomeHeaderNavigation = ({  setShowSidebar }) => {

    const navigate = useNavigate()
    const { pathname = ''} = useLocation();
    const handleClick = (view) =>{
        navigate(`/${view}`)
        if(setShowSidebar){
            setShowSidebar(false)
        }
    }

    const getIcon = (id) => {
        switch(id) {
            case 'analyze': return <BarChart2 size={20} className="mr-3" />;
            case 'myresumes': return <FileText size={20} className="mr-3" />;
            case 'craft': return <Wand2 size={20} className="mr-3" />;
            default: return null;
        }
    }

    return (
        <nav className="flex flex-col md:flex-row md:justify-center md:gap-2 justify-start items-stretch w-full p-4 md:p-0 text-base">
            {NAVIGATION_ITEMS.map((item) => {
                const isActive = item.exact ? pathname.toLowerCase() === item.matchPath : pathname.toLowerCase().startsWith(item.matchPath)

                return (
                    <button 
                        key={item.id}
                        onClick={() => handleClick(item.path)} 
                        className={`flex items-center w-full md:w-auto py-3 px-4 rounded-lg transition-colors ${
                            isActive 
                            ? 'bg-indigo-50 text-indigo-600 font-semibold' 
                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                        }`}
                    >
                        {getIcon(item.id)}
                        {item.label}
                    </button>
                )
            })}
        </nav>
    )
}